<div class="fp-split-table" *ngIf="viewModel$ | async as vm">

  <div class="fp-split-row" *ngFor="let row of vm.rows; trackBy: trackByRow">

    <p-dropdown
      class="fp-split-franchise"
      appendTo="body"
      [options]="row.options"
      optionLabel="name"
      optionValue="id"
      placeholder="Select a franchise partner"
      [ngModel]="row.franchiseId"
      (ngModelChange)="onFranchiseSelected(vm.selectedIds, row.franchiseId, $event)"
    ></p-dropdown>

    <div class="p-inputgroup fp-split-amount">
      <p-inputNumber
        #amountInput
        mode="currency"
        [currency]="vm.currency"
        [locale]="vm.currency === 'CAD' ? 'en-CA' : 'en-US'"
        [disabled]="!row.franchiseId"
        [ngModel]="row.hasOverride ? row.amount : null"
        [placeholder]="row.franchiseId ? amountInput.formatValue(row.amount) : ''"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        (ngModelChange)="row.franchiseId && onAmountInput(row.franchiseId, $event)"
        (onBlur)="row.franchiseId && commitAmount(row.franchiseId)"
      ></p-inputNumber>
      <button
        *ngIf="row.hasOverride && row.franchiseId"
        pButton
        type="button"
        icon="pi pi-replay"
        class="p-button-text"
        title="Reset to auto-filled amount"
        (click)="resetAmount(row.franchiseId)"
      ></button>
    </div>

    <button
      pButton
      type="button"
      icon="pi pi-times"
      class="p-button-text p-button-danger fp-split-remove"
      title="Remove franchise partner"
      (click)="removeRow(vm.selectedIds, row)"
    ></button>

  </div>

  <button
    *ngIf="vm.canAddRow"
    pButton
    type="button"
    icon="pi pi-plus"
    label="Add franchise partner"
    class="p-button-text p-button-sm fp-split-add"
    (click)="addRow()"
  ></button>

</div>
